<template>
    <div class="loading-container">
        <div class="task-body">
            <h2>Provider Identification Updated</h2>
            <router-link class="primary-link" :to="`/manage/executives/${item.primaryEntityId}/identification`"
                >Load Executive {{ item.description }}</router-link
            >
            <DeltaView v-if="!updating" :deltaView="deltaView" />
            <div class="loading" v-else>
                <loading :active="updating" :is-full-page="false" />
            </div>
        </div>
        <div class="task-actions">
            <button @click="complete" class="primary">Complete</button>
        </div>
    </div>
</template>
<script setup>
import TaskService from '@/services/manage/taskService'
import ExecutiveService from '@/services/manage/executiveService'
import DeltaView from '@/components/shared/delta-view.vue'
import { computed, inject } from 'vue'
import { asyncComputed } from '@/utils/asyncComputed'

const props = defineProps({
    item: {
        type: Object,
        required: true,
    },
})

const deltaView = asyncComputed(
    () => ExecutiveService.getExecutiveIdentificationDeltas(props.item.primaryEntityId, props.item.secondaryEntityId),
    {}
)
const updating = computed(() => deltaView.updating)

const flash = inject('flash')
async function complete() {
    await TaskService.complete(props.item)
    flash('Task cleared.', 'success')
}
</script>
